module.exports = __webpack_public_path__ + "img/chat_emoticon_synot_008.png?408a5ff7520e1146cfa8eb413a0a55b2";